import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import OurExpertise from "./sections/OurExpertise";
import TheBenewealthAdvantage from "./sections/TheBenewealthAdvantage";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <OurExpertise />
      <TheBenewealthAdvantage />
      <Footer />
    </div>;
}